// Hook do pobierania listy załączników zgłoszenia reklamacyjnego (Panel Klienta)

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IReturnComplaintAttachment {
  id: number;
  name: string;
  url: string | null;
  original_filename: string;
  extension: string;
}

interface IResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: IReturnComplaintAttachment[];
}

const getReturnComplaintAttachments = (id: number | string): Promise<IResponse> =>
  axios.get(`/return-complain/requests/${id}/attachments`);

export const useGetReturnComplaintAttachments = (
  id: number | string,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['return-complaint-attachments', id],
    () => getReturnComplaintAttachments(id),
    { enabled: !!id && id !== 'new', ...options }
  );
